import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateDoctoralDisciplines = () => {
  return (
    <Create
      title="Създаване на докторантска дисциплина"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};

export default CreateDoctoralDisciplines;
